import { gtmEventPush, gtmDatalayerPushData } from './modules/ga/GTMdatalayer';
import {onLCP, onINP, onCLS, onTTFB, onFCP} from 'web-vitals';
import { readCookie, createCookie } from './utils/Cookie';

const queue = new Set();
function addToQueue(metric) {
  queue.add({[metric.name] : (Math.round(metric.value * 100)/100)}); //rounding off to the nearest compatible value
}

function flushQueue() {
    if (queue.size > 0) {
      const body = JSON.stringify([...queue]);
      if(!readCookie('perf')){
        createCookie('perf', false, 2);
      }
        gtmEventPush({
            event: "pv_performance",
            web_variant_name: body,
            perf: readCookie('perf') || false
        })
  
      queue.clear();
    }
}

onCLS(addToQueue);
onINP(addToQueue);
onLCP(addToQueue);
onFCP(addToQueue);
onTTFB(addToQueue);

addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      flushQueue();
    }
});

addEventListener('pagehide', flushQueue); //for Safari
